import React from 'react';
import PropTypes from 'prop-types';
import { ACCOUNTS, SUPER_ADMIN } from '../../../../../../utils/departments/helpers';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import AccountsNavBar from '../../../../../layouts/accounts/AccountsNavBar';
import PurchaseOrderBody from '../../../procurement/purchase-order/departments/PurchaseOrderBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';

const CFOInterDepartmentalPO = ({ history }) => {
  useCheckTwoDepartments(`${ACCOUNTS}`, `${SUPER_ADMIN}`, history);
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <span className="d-none d-md-block">
          <AccountsNavBar currentPage="InterDepartmental Purchase Order" position={firstName} />
        </span>
        <span className="d-md-none d-block">
          <AccountsNavBar currentPage="InterDepartmental PO" position={firstName} />
        </span>
        {Number(sessionStorage.getItem('roleId')) === 9 ? <PurchaseOrderBody /> : null}
      </main>
    </div>
  );
};

CFOInterDepartmentalPO.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default CFOInterDepartmentalPO;
